import BookMain from "../components/Books/BookMain"

const Book = () => {
  return (
    <>
    <BookMain/>
    </>
  )
}

export default Book